import React from 'react';
import { useProfile } from '../../hooks/useProfile';
import { Lock } from 'lucide-react';
import SubmissionList from '../../components/admin/SubmissionList';
import Hero from '../../components/ui/Hero';

const AdminPage: React.FC = () => {
  const { isAdmin, isLoading } = useProfile();

  if (isLoading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div>
      <Hero
        title="Admin Dashboard"
        description="Review and manage animatronic submissions"
        compact
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {isAdmin ? (
          <SubmissionList />
        ) : (
          <div className="text-center py-12">
            <Lock className="w-12 h-12 text-brand mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-4">Admin Access Required</h2>
            <p className="text-content-secondary max-w-md mx-auto">
              This page is only accessible to administrators. If you believe you should have access, please contact support.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPage;